import React, { useState, useEffect, useRef, useContext } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { useDispatch, useSelector } from 'react-redux';
import { hide, show } from 'redux-modal';
import { Archive, Edit, Unarchive, ChevronLeft } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';
import ClassMissionImage from '../../assets/missions/class-missions.png';
import ClassMissionTrialExtendedImage from '../../assets/missions/class-missions-trial-extended.png';
import View from '../../components/view/View';
import Table from '../../components/table/Table';
import SearchBar from '../../components/searchbar/SearchBar';
import Button from '../../components/button/Button';
import InfoBanner from '../../components/info-banner/InfoBanner';
import {
  MODAL_ADD_CLASS,
  MODAL_DEFAULT,
  MODAL_EDIT_CLASS
} from '../../constants/modals';
import { archiveClass } from '../../redux/actions/class-actions';
import { useLocation } from 'react-router';
import { userTypes } from '../../constants/users';
import { userRouteGetter } from '../../utils/user-route-getter';
import { Typography, makeStyles } from '@material-ui/core';
import { getPlanner } from '../../redux/actions/planner-actions';
import classIconRegular from '../../assets/icons/class-icon.png';
import classIconPremium from '../../assets/icons/class-icon-premium.png';
import classIconPremiumPlus from '../../assets/icons/class-icon-premium-plus.png';
import archivedClassIcon from '../../assets/icons/archived-class-icon.png';
import { isMobile } from 'react-device-detect';
import colors from '../../styles/colors';
import clsx from 'clsx';
import { push } from 'connected-react-router';
import { UserType } from '../../enums/UserType';
import {
  isUserSeenClassMission,
  isUserSeenClassMissionTrialExtended,
  setClassMissionModalSeen,
  setClassMissionTrialExtendedModalSeen
} from '../../utils/user';
import teacherFeatureFlagContext from '../../layouts/teacher/TeacherFeatureFlagContext';
import { PriceIncreaseBanner } from '../../components/banner/PriceIncreaseBanner';
import { teacherRoutes } from '../../constants/routes';
import { useAppSelector } from '../../redux/hooks';
import { LEMigrationStatusBanner } from '../../components/banner/LEMigrationStatusBanner';
import { fetchApi } from '../../redux/actions/fetch-actions';
import { APIEndpoints, APIMethods } from '../../types/fetch/fetch-types';
import moment from 'moment';

const useStyles = makeStyles(() => ({
  enterClassNotification: {
    alignItems: 'center',
    background: '#f2f2f2',
    borderRadius: 5,
    border: '1px solid #dcdcdc',
    display: 'flex',
    left: '90%',
    minWidth: '110%',
    padding: 10,
    position: 'absolute',
    top: 3,
    width: 'auto',
    zIndex: 9
  },
  enterClassArrow: {
    background: colors.primary,
    borderRadius: '50%',
    color: colors.white,
    marginRight: 20
  }
}));

const ClassReportsView: React.FC<any> = (props: any) => {
  const dispatch = useDispatch();
  const { match } = props;
  const userData = useSelector((state: any) => state.userData);
  const featureFlag = useSelector((state: any) => state.featureFlag);
  const isPremiumUser = userData.premium && userData.premium.isPremium;
  const { classes } = useSelector((state: any) => state.class);
  const { currentTeacher } = useSelector((state: any) => state.admin);
  const userType: string = userRouteGetter(userData.userType);
  const premiumType = isPremiumUser ? userData.premium.type : '';
  const [showArchived, setShowArchived] = useState(false);
  const styles = useStyles();
  const prevClassesLengthRef = useRef();
  const features = useAppSelector(state => state.featureFlag);
  const [migrationComplete, setMigrationComplete] = useState(false);
  const location = useLocation();
  const token = useAppSelector(state => state.login.token);

  const [classIcon] = useState(() => {
    if (
      (isPremiumUser && premiumType === 'Premium') ||
      premiumType === 'Premium29'
    ) {
      return classIconPremium;
    } else if (isPremiumUser && premiumType === 'PremiumPlus') {
      return classIconPremiumPlus;
    } else {
      return classIconRegular;
    }
  });
  const filterClasses = () => {
    return classes.filter((e: any) => {
      return e.archived === showArchived;
    });
  };

  const [classData, setClassData] = useState(filterClasses());
  const [searchState, setSearchState] = useState(classData);

  useEffect(() => {
    async function checkMigrationStatus() {
      const learnerIds = classes
        .map((classData: any) =>
          classData.roster.map((learner: any) => learner.educationUserId)
        )
        .flat();

      const response = await dispatch(
        fetchApi({
          url: `v1/migrations`,
          method: APIMethods.POST,
          endpoint: APIEndpoints.LE_API,
          data: {
            learners: learnerIds
          }
        })
      );
      if (response.data.status === 'Done') {
        setMigrationComplete(true);
      } else {
        setMigrationComplete(false);
      }
    }

    if (features.newLearningEngine) {
      checkMigrationStatus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [features.newLearningEngine, dispatch]);

  useEffect(() => {
    prevClassesLengthRef.current = classes.length;
  }, [classes]);

  useEffect(() => {
    const classes = filterClasses();
    setClassData(classes);
    setSearchState(
      classes.sort((a: any, b: any) => {
        if (b._id - a._id) return 1;
        return -1;
      })
    );

    if (
      classes.length === 1 &&
      prevClassesLengthRef.current === 0 &&
      userData.userType === userTypes.teacher
    ) {
      const classCode = classes[0].code;
      dispatch(push(`/dashboard/teacher/class/${classCode}`));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classes, showArchived]);

  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_NEW_DASHBOARD_URL}/?accessToken=${token}`;

    return () => {
      if (location.pathname === '/dashboard/teacher') {
        dispatch(hide('modal'));
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const handleAddClass = (hideCloseButton: boolean = false) => {
    dispatch(
      show('modal', {
        type: MODAL_ADD_CLASS,
        title: 'Add Class',
        message: 'Please add class over here',
        hideCloseButton
      })
    );
  };

  const handleArchiveClass = (id: string, archive: boolean) => {
    dispatch(hide('modal'));
    dispatch(archiveClass(id, archive));
  };

  const renderAddStudentsNotification = () => {
    if (classes.length === 1 && !classes[0].roster.length && !isMobile) {
      return (
        <div className={styles.enterClassNotification}>
          <ChevronLeft
            className={clsx('bounce-left', styles.enterClassArrow)}
          />{' '}
          Great! Now, enter your class to add your students.
        </div>
      );
    }
    return null;
  };

  const columns = [
    {
      Header: 'Class Name',
      accessor: 'name',
      Cell: (row: any) => {
        return (
          <>
            <NavLink
              onClick={() => {
                const { code } = row.row.values;
                dispatch(getPlanner(code));
              }}
              to={`/dashboard/${userType}/class/${row.row.values.code}`}
              style={{
                textDecoration: 'underline',
                color: 'inherit',
                display: 'block'
              }}
            >
              {!isMobile ? (
                <img
                  src={showArchived ? archivedClassIcon : classIcon}
                  style={{ opacity: 0.8, verticalAlign: 'top', width: '64px' }}
                />
              ) : null}
              <span
                style={{
                  verticalAlign: 'top',
                  margin: '24px 0 0 10px',
                  display: 'inline-block',
                  textDecoration: 'underline'
                }}
              >
                {row.row.values.name}
              </span>
              {renderAddStudentsNotification()}
            </NavLink>
          </>
        );
      }
    },
    {
      Header: () => {
        return <div style={{ textAlign: 'center' }}>Number of students</div>;
      },
      Cell: (row: any) => (
        <div style={{ textAlign: 'center', marginTop: '14px' }}>
          {row.row.original.roster.length}
        </div>
      ),
      accessor: 'roster'
    },
    {
      Header: () => <div style={{ textAlign: 'center' }}>Class Code</div>,
      accessor: 'code',
      Cell: (row: any) => (
        <div style={{ textAlign: 'center', marginTop: '14px' }}>
          {row.row.original.code}
        </div>
      )
    },
    {
      Header: () => <div style={{ textAlign: 'center' }}>Actions</div>,
      accessor: 'actions',
      Cell: (row: any) => {
        const archiveAction = !row.row.original.archived;
        return (
          <div style={{ textAlign: 'center', marginTop: '14px' }}>
            <Tooltip title="Edit Class">
              <Button
                onClick={() => {
                  dispatch(
                    show('modal', {
                      type: MODAL_EDIT_CLASS,
                      id: row.row.original._id,
                      className: row.row.original.name,
                      match
                    })
                  );
                }}
              >
                <Edit />
              </Button>
            </Tooltip>
            <Tooltip
              title={`${
                row.row.original.archived ? 'Unarchive' : 'Archive'
              } Class`}
            >
              <Button
                onClick={() => {
                  dispatch(
                    show('modal', {
                      type: MODAL_DEFAULT,
                      title: row.row.original.archived
                        ? 'Unarchive class'
                        : 'Are you sure you want to archive this class?',
                      children: () => {
                        if (row.row.original.archived) {
                          return (
                            <p>
                              Are you sure you want to unarchive this class?
                            </p>
                          );
                        }
                        if (isPremiumUser) {
                          return (
                            <p>
                              Archiving this class will end the player
                              memberships for these players. They will still be
                              able to use their accounts and play Dreamscape.
                            </p>
                          );
                        } else {
                          return (
                            <p>
                              players in archived classes will still be able to
                              use their accounts and play Dreamscape.
                            </p>
                          );
                        }
                      },
                      actions: () => {
                        return (
                          <>
                            <Button
                              primary
                              onClick={() =>
                                handleArchiveClass(
                                  row.row.original._id,
                                  archiveAction
                                )
                              }
                            >
                              Yes
                            </Button>
                          </>
                        );
                      }
                    })
                  );
                }}
              >
                {row.row.original.archived ? <Unarchive /> : <Archive />}
              </Button>
            </Tooltip>
          </div>
        );
      }
    }
  ];

  const toggleArchived = () => {
    setShowArchived(!showArchived);
  };

  const { flags } = useContext(teacherFeatureFlagContext);

  // @deprecated
  const isClassMissionTrialUser =
    flags.classMissionTrials && !isUserSeenClassMission();

  const isClassMissionTrialExtendedUser =
    flags.classMissionTrialsExtended && !isUserSeenClassMissionTrialExtended();

  // @deprecated
  const showClassMissionTrialModal = (triggerAddClass = false) => {
    if (isClassMissionTrialUser) {
      dispatch(
        show('modal', {
          type: MODAL_DEFAULT,
          title: 'Class Missions are FREE all week!',
          dividers: true,
          showTitleClose: true,
          hideActions: true,
          handleTitleClose: () => {
            dispatch(hide('modal'));
            if (triggerAddClass) {
              handleAddClass(true);
            }
            setClassMissionModalSeen();
          },
          children: (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <p>
                  Guess what? <strong>Class Missions are FREE</strong> for all
                  educators until May 21, 2022. Watch your class work together
                  while focusing on practicing their skills. Great for testing
                  season!
                </p>
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <img src={ClassMissionImage} />
              </Grid>
            </Grid>
          )
        })
      );
    }
  };

  const closeClassMissionsTrialExtendedModal = (
    triggerAddClass: boolean
  ): void => {
    dispatch(hide('modal'));
    setClassMissionTrialExtendedModalSeen();
    if (triggerAddClass) {
      handleAddClass(true);
    }
  };

  const showClassMissionTrialExtendedModal = (triggerAddClass = false) => {
    if (isClassMissionTrialExtendedUser) {
      dispatch(
        show('modal', {
          type: MODAL_DEFAULT,
          title: 'Trial EXTENDED until May 21!',
          dividers: true,
          showTitleClose: true,
          hideActions: true,
          handleTitleClose: () => {
            closeClassMissionsTrialExtendedModal(triggerAddClass);
          },
          children: (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <p>
                  Usually it’s the students who get extensions. Enjoy another
                  week of Class Missions on us, look for the free trial
                  notification in your dashboard. Thanks for trying out the new
                  feature!
                </p>
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <img
                  src={ClassMissionTrialExtendedImage}
                  alt="Class Mission"
                  style={{ maxWidth: '100%' }}
                />
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Button
                  primary
                  onClick={() =>
                    closeClassMissionsTrialExtendedModal(triggerAddClass)
                  }
                >
                  Hurray!
                </Button>
              </Grid>
            </Grid>
          )
        })
      );
    }
  };

  console.log('userData.newRegistrationFlow', userData.newRegistrationFlow);
  if (userData.userType === UserType.Teacher) {
    if (
      featureFlag.newRegistrationFlow &&
      (userData.newRegistrationFlow === 'B' ||
        userData.newRegistrationFlow === 'C') &&
      userData.dreamscape.registrationStep === 1 &&
      !classData.length
    ) {
      handleAddClass(true);
    } else {
      if (
        userData.dreamscape.registrationStep === 2 &&
        userData.newRegistrationFlow === 'A'
      ) {
        const hideCloseButton = true;
        if (isClassMissionTrialExtendedUser) {
          showClassMissionTrialExtendedModal(true);
        } else if (isClassMissionTrialUser) {
          showClassMissionTrialModal(true);
        } else if (!classData.length) {
          console.log('show add classs');
          handleAddClass(hideCloseButton);
        }
      } else if (!userData.premium || !userData.premium.isPremium) {
        /**
         * @description class mission trials popup
         */
        if (isClassMissionTrialExtendedUser) {
          showClassMissionTrialExtendedModal();
        } else {
          showClassMissionTrialModal();
        }
      }
    }
  }

  const classDisplay = showArchived ? 'Archived' : '';
  const title = [userTypes.schoolAdmin, userTypes.districtAdmin].includes(
    userData.userType
  )
    ? `${currentTeacher.firstName || ''} ${currentTeacher.lastName ||
        ''}'s ${classDisplay} Classes`
    : `My ${classDisplay} Classes`;

  const handleUpgrade = () => {
    dispatch(push(teacherRoutes.teacherPremiumPlan));
  };

  const showMigrationPendingBanner = () => {
    const isEqualCreatedFFTDate = moment(
      userData?.createdDate,
      'DD-MM-YYYY'
    ).isSame(moment(userData?.featureFlagDate, 'DD-MM-YYYY'));
    return (
      features.newLearningEngine && !migrationComplete && !isEqualCreatedFFTDate
    );
  };

  const showMigrationDoneBanner = () => {
    if (features.newLearningEngine) {
      const today = moment();
      const optInDate = moment(userData?.featureFlagDate);
      const daysPassed = today.diff(optInDate, 'days') + 1;
      const isEqualCreatedFFTDate = moment(
        userData?.createdDate,
        'DD-MM-YYYY'
      ).isSame(moment(userData?.featureFlagDate, 'DD-MM-YYYY'));
      return migrationComplete && daysPassed < 15 && !isEqualCreatedFFTDate;
    }
    return false;
  };

  return (
    <>
      {showMigrationPendingBanner() && (
        <LEMigrationStatusBanner
          text="Your players' data is being migrated. Please check back later."
          color="#DB7C0C"
        />
      )}
      {showMigrationDoneBanner() && (
        <LEMigrationStatusBanner
          text="Your players' data has been successfully migrated."
          color="#4CAF50"
        />
      )}
      <PriceIncreaseBanner handleUpgrade={handleUpgrade} />
      <View title={title}>
        <Grid container spacing={8} alignItems="center">
          <Grid item lg={4} xs={12}>
            <SearchBar
              searchKey="name"
              placeholder="Search by Class Name"
              originalState={classData}
              onChange={(searchState: any) => setSearchState(searchState)}
            />
          </Grid>
          <Grid
            item
            lg={8}
            xs={12}
            style={{
              textAlign: 'right'
            }}
          >
            <Button onClick={toggleArchived} style={{ marginRight: 10 }}>
              {showArchived ? 'Show Unarchived' : 'Show Archived'}
            </Button>
            <Button primary onClick={() => handleAddClass(false)}>
              Add Class
            </Button>
          </Grid>
        </Grid>
        <br />
        {classData.length > 0 ? (
          <Grid item lg={12}>
            <Table columns={columns} data={searchState} />
          </Grid>
        ) : (
          <Typography component="h2" variant="h6">
            No classes available
          </Typography>
        )}

        {userData.userType === userTypes.parent && (
          <>
            <InfoBanner
              title="Getting Started"
              text="Click to the left to see and get started"
            />
            <br />
            <InfoBanner text="Games" title="Referral Program" />
          </>
        )}
      </View>
    </>
  );
};

export default withRouter(ClassReportsView);
